var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vb-tooltip-slot',{attrs:{"content":_vm.description}},[_c('v-icon',{staticClass:"info-button",attrs:{"aria-label":_vm.description,"small":""}},[_vm._v(" mdi-information-variant ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }